import { createContext } from "react";
import { IbanXSBanksRecipientsPivot } from "ui/forms/OpenBanking";

type Context = IbanXSBanksRecipientsPivot.IbanXSBanksRecipientsPivotProps;

export const IbanXSBanksRecipientsPivotFormContext = createContext<Context>({} as Context);
